import { combineReducers } from 'redux';
import base from './base';

export default combineReducers({
    base
});